import { ol_Map, ol_Overlay } from "@omnia/exports/openlayers"
import { IFieldsMapContainerContext } from "../../fields/map"
import { LayerTypeId } from "../../generated/enums"
import { Layer } from "../../map/layer"
import { createPictureOverlay } from "../../map/pictureOverlay"
import { Datalayer } from "../datalayer"
import { DatalayerZone } from "../datalayerZone"

export class PicturesMapState {

    private pictureOverlays: { layer: Datalayer, zone: DatalayerZone, overlay: ol_Overlay }[] = []

    constructor(private readonly olmap: ol_Map, private readonly ctxt: IFieldsMapContainerContext) {
    }

    public onLayerAdded(layer: Layer, edit: boolean) {

        if (edit) return
        if (!(layer instanceof Datalayer)) return
        if (layer.typeId != LayerTypeId.Drawing) return

        const { olmap } = this

        layer.zones.filter(z => z.picture).forEach(zone => {

            if (zone.feature && !this.pictureOverlays.find(o => o.zone.id === zone.id)) {

                const { overlay } = createPictureOverlay(
                    this.ctxt.$rootScope,
                    this.ctxt.$compile,
                    zone.feature,
                    zone.picture
                )

                olmap.addOverlay(overlay);

                this.pictureOverlays.push({ layer, zone, overlay });

            }
        });

        olmap.render();

    }

    public onLayerRemoved(layer: Layer, edit: boolean) {

        if (edit) return
        if (!(layer instanceof Datalayer)) return
        if (layer.typeId != LayerTypeId.Drawing) return

        this.removePictureOverlaysForLayerId(layer.datalayerId)


    }

    removePictureOverlays(): void {
        const { olmap } = this
        this.pictureOverlays.forEach(o => olmap.removeOverlay(o.overlay));
        this.pictureOverlays = [];
    }

    removePictureOverlaysForLayerId(layerId: number): void {
        const { olmap } = this
        this.pictureOverlays.filter(o => o.layer.datalayerId === layerId).forEach(o => olmap.removeOverlay(o.overlay));
        this.pictureOverlays = this.pictureOverlays.filter(o => o.layer.datalayerId !== layerId);
    }

    refresh(layers: Layer[]) {

        if (this.pictureOverlays) {
            var layersIds = layers.filter(l => l instanceof Datalayer).map(l => (<Datalayer>l).datalayerId);
            var removedLayers = this.pictureOverlays.filter(o => layersIds.indexOf(o.layer.datalayerId) === -1);
            removedLayers.forEach(l => this.removePictureOverlaysForLayerId(l.layer.datalayerId));
        }

    }

}
